import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const usePermission = (defaultPageSize, isFetch) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "",
    description: "", 
  });

  useUpdateEffect(() => {
    fetchList(); 
   }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/permission/list", filter)
      setItems(response.data.permissions);
      setTotal(response.data.total);
      return response.data.permissions
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 0
      };

      const response = await automobyApi.post("/permission/all", requestData)
      setItems(response.data.permissions);
      setTotal(response.data.total);
      return response.data.permissions
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/permission/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (permission, count) => {
    try {
      const requestData = {
        permission: permission,
        count: count,
      };

      const response = await automobyApi.post("/permission/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/permission/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          permission_id: id
        };
        const response = await automobyApi.post(`/permission/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 
 
  const updateLocal = async (permission) => {
    setItems(items.map(item =>
      item.id === permission.id ? permission : item
    ));
  }
 

  const permissionService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove,  
  };

  return { permissionService };
}